import axios from 'axios';
import qs from 'qs';

import config from '@/env';

import * as Util from './crypto';


const http = (url, data, au = null) => {
  console.log('request', { url, data });
  const reqObj = Object.assign({ requestInfo: { systemName: 'TO_PRIVATE_APP' } }, data);
  const timestamp = `${Util.uuid()}-${Util.getTimeStamp()}`;
  const aesObj = Util.getReqData(reqObj, timestamp);
  const requestRUL = config.baseUrl + url;

  return new Promise((resolve, reject) => {
    axios({
      url: requestRUL,
      method: 'post',
      data: { body: aesObj },
      headers: Util.authorization(timestamp, aesObj, au),
      transformRequest: [(req) => {
        console.log('地址:', requestRUL);
        return qs.stringify(req);
      }],
      transformResponse: [(resp) => {
        console.log('response', { url, data: Util.getRepData(resp) });
        return Util.getRepData(resp);
      }],
      timeout: 30000,
    }).then((res) => {
      resolve(res.data);
    }).catch((e) => {
      reject(e);
    });
  });
};

export default http;
